import { Footer } from "../../components/Footer/Footer"
import { Header } from "../../components/Header/Header"
import LoreArticle from "./LoreArticle/LoreArticle"

const LoreArticlePage = () => {
    return (
        <>
            <Header />
            <LoreArticle />
            <Footer /> 
        </>
    )
}

export default LoreArticlePage